import type { RouteRecordRaw } from 'vue-router';

export const tradeShippingRoutes: Array<RouteRecordRaw> = [
  {
    path: '/trade/shipping/method',
    name: 'tradeShippingMethod',
    redirect: '/trade/shipping/method/list',
    component: () => import('pages/trade/admin/shipping/method/ShippingMethod.vue'),
    meta: {
      title: 'Shipping Methods',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'tradeShippingMethodList',
        component: () => import('pages/trade/admin/shipping/method/ShippingMethodList.vue'),
        meta: {
          title: 'Shipping Methods List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'tradeShippingMethodDetail',
        component: () => import('pages/trade/admin/shipping/method/ShippingMethodDetail.vue'),
        meta: {
          title: 'Shipping Method Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?',
        name: 'tradeShippingMethodNew',
        component: () => import('pages/trade/admin/shipping/method/ShippingMethodNew.vue'),
        meta: {
          title: 'New Shipping Method',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/shipping',
    name: 'tradeShipping',
    redirect: '/trade/shipping/list',
    component: () => import('pages/trade/admin/shipping/TradeShipping.vue'),
    meta: {
      title: 'Trade [Order] Shipping',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeShippingList',
        component: () => import('pages/trade/admin/shipping/ShippingList.vue'),
        meta: {
          title: 'Trade [Order] Shipping List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'tradeShippingDetail',
        component: () => import('pages/trade/admin/shipping/ShippingDetail.vue'),
        meta: {
          title: 'Trade [Order] Shipping Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'tradeShippingNew',
        component: () => import('pages/trade/admin/shipping/ShippingNew.vue'),
        meta: {
          title: 'New Shipping',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/trade/item/shipping',
    name: 'tradeItemShipping',
    redirect: '/trade/item/shipping/list',
    component: () => import('pages/trade/admin/shipping/item/ItemShipping.vue'),
    meta: {
      title: 'Item Shipping Costs',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'tradeItemShippingList',
        component: () => import('pages/trade/admin/shipping/item/ItemShippingList.vue'),
        meta: {
          title: 'Item Shipping Costs List',
          requiresAuth: true,
          // /:shipId?/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?
        },
      },
      {
        path: 'detail',
        name: 'tradeItemShippingDetail',
        component: () => import('pages/trade/admin/shipping/item/ItemShippingDetail.vue'),
        meta: {
          title: 'Item Shipping Cost Details',
          requiresAuth: true,
          // /:itemId?/:shipId?/:productId?/:inventoryId?/:groupId?/:categoryId?/:appId?
        },
      },
      {
        path: 'new',
        name: 'tradeItemShippingNew',
        component: () => import('pages/trade/admin/shipping/item/ItemShippingNew.vue'),
        meta: {
          title: 'New Item Shipping Cost',
          requiresAuth: true,
        },
      },
    ],
  },
];
